import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import {
  DealItem,
  DealItemWithVersions,
} from '@/lib/graphql/generated/graphql';
import { Row } from '@tanstack/react-table';

import { ExtendedColumnDef } from '../table-products';

const linesToText = (arr?: string[] | null | string): string => {
  if (typeof arr === 'string') return arr;
  return arr && arr.length ? arr.join('\n') : '';
};

const useColumnDefCouponTerms = (): ExtendedColumnDef<DealItemWithVersions> => {
  const { t } = useTranslation();

  const getValue = (row: Row<DealItemWithVersions>) => {
    return row.original.activeVersion.couponTerms;
  };

  const getParentValue = () => {
    return '—';
  };

  const accessorKey: keyof DealItem = 'couponTerms';
  return useMemo(
    () => ({
      accessorKey: accessorKey,
      name: 'CGU',
      header: () => (
        <div className="flex items-center">{t('kpi.coupon_terms')}</div>
      ),
      cell: ({ row }) => {
        const isParent = row.subRows.length > 1;
        const displayValue = isParent ? getParentValue() : getValue(row);

        return (
          <div className="h-full w-full">
            <Tooltip>
              <TooltipTrigger asChild>
                <div className="flex h-full w-full max-w-[200px] items-center truncate px-2 text-sm">
                  {linesToText(displayValue as string[] | null) || '—'}
                </div>
              </TooltipTrigger>
              <TooltipContent>
                <div className="max-w-[300px] whitespace-pre-wrap">
                  {linesToText(displayValue as string[] | null) ||
                    t('kpi.coupon_terms_none')}
                </div>
              </TooltipContent>
            </Tooltip>
          </div>
        );
      },
      size: 280,
    }),
    [t]
  );
};

export default useColumnDefCouponTerms;
